import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiConfiguration } from '@klubovna/api-client';
import {
  albumsControllerFindAll,
  AlbumsControllerFindAll$Params,
  albumsControllerFindAllByEventSlug,
  AlbumsControllerFindAllByEventSlug$Params,
  albumsControllerFindOne,
  albumsControllerFindOneBySlug,
} from '@klubovna/api-client';
import { AlbumResponse } from '@klubovna/api-client';
import { PaginatedResponse, toPaginatedResponse } from '@klubovna/api-client';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface AlbumsQueryParams {
  page?: number;
  limit?: number;
  search?: string;
  tagIds?: string[];
  sortBy?: 'eventDate' | 'createdAt' | 'name' | 'photoCount';
  sortOrder?: 'ASC' | 'DESC';
}

@Injectable({
  providedIn: 'root',
})
export class AlbumsApiService {
  private http = inject(HttpClient);
  private apiConfig = inject(ApiConfiguration);

  findAll(params?: AlbumsQueryParams): Observable<PaginatedResponse<AlbumResponse>> {
    const apiParams: AlbumsControllerFindAll$Params = {
      page: params?.page,
      limit: params?.limit,
      search: params?.search,
      isActive: true,
      tagIds: params?.tagIds,
      sortBy: params?.sortBy,
      sortOrder: params?.sortOrder,
    };

    return albumsControllerFindAll(this.http, this.apiConfig.rootUrl, apiParams).pipe(
      map((response) => toPaginatedResponse<AlbumResponse>(response.body)),
    );
  }

  findAllByEventSlug(slug: string, params?: AlbumsQueryParams): Observable<PaginatedResponse<AlbumResponse>> {
    const apiParams: AlbumsControllerFindAllByEventSlug$Params = {
      slug,
      page: params?.page,
      limit: params?.limit,
      search: params?.search,
      isActive: true,
      tagIds: params?.tagIds,
      sortBy: params?.sortBy,
      sortOrder: params?.sortOrder,
    };

    return albumsControllerFindAllByEventSlug(this.http, this.apiConfig.rootUrl, apiParams).pipe(
      map((response) => toPaginatedResponse<AlbumResponse>(response.body)),
    );
  }

  findOneById(id: string): Observable<AlbumResponse> {
    return albumsControllerFindOne(this.http, this.apiConfig.rootUrl, { id }).pipe(
      map((response) => response.body as AlbumResponse),
    );
  }

  findOneBySlug(slug: string): Observable<AlbumResponse> {
    return albumsControllerFindOneBySlug(this.http, this.apiConfig.rootUrl, { slug }).pipe(
      map((response) => response.body as AlbumResponse),
    );
  }
}
